import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Upload } from 'antd';
import { CouponService } from "./../../services/CouponService";


interface Props {
    record: {
        id: number
        coupon: {
            expired_date: string
            id: number
            name: string
            start_date: string
        }
    }
    onFinish: () => void
}

export default function AddUserCoupon(props: Props) {


    const [form] = Form.useForm();
    const [coupons, setCoupons] = React.useState();

    React.useEffect(() => {
        getCoupons();
    }, [])


    const getCoupons = async () => {
        const res = await CouponService.getCoupons({
            page: 1,
            perPage: 500,
            is_public: 1,
            is_expired: 0
        });

        setCoupons(res.data.map((item: any) => {
            return {
                label: item.name,
                value: item.id
            }
        }))




    }





    const onFinish: FormProps["onFinish"] = async (values) => {



        const res = await CouponService.saveUserCoupon(values)

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            form.resetFields();
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            title={'Add User Coupon'}
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    coupon_id: null,
                    tel: '',
                    code: '',
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Coupon"
                    name="coupon_id"
                    rules={[{ required: true, message: 'Please fill coupon id' }]}
                >
                    <Select
                        placeholder="Please choose coupon"
                        style={{ width: 250 }}
                        onChange={(value) => {
                            form.setFieldValue('coupon_id', value)
                        }}
                        options={coupons}
                    />
                </Form.Item>

                <Form.Item
                    label="User (Phone Number)"
                    name="tel"
                    extra="Ex. 66893334444"
                    rules={[{ required: true, message: 'Please fill phone number' }]}
                >
                    <Input />
                </Form.Item>


                <Form.Item
                    label="Code"
                    name="code"
                    rules={[{ required: true, message: 'Please fill coupon code' }]}
                >
                    <Input />
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
